import { ReactNode } from 'react';
import cn from 'classnames';
import styles from './card.module.scss';

export interface IInfoCardProps {
  text: string;
  color?:
    | 'none'
    | 'black-gradient'
    | 'yellow-gradient'
    | 'dark-gradient'
    | 'green-gradient';
  center?: boolean;
  icon?: ReactNode;
  className?: string;
}

const InfoCard = ({
  text,
  color = 'none',
  center = false,
  icon,
  className = '',
}: IInfoCardProps): JSX.Element => {
  const classNames = cn(styles.card, className, {
    [styles.center]: center,
    [styles[`card-color-${color}`]]: color,
  });

  return (
    <div className={classNames}>
      {icon}
      <span>{text}</span>
    </div>
  );
};

export default InfoCard;
